var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-box -padding-0 -gray grid-x grid-margin-x"},[_c('div',{staticClass:"cell align-middle"},[_c('quick-filter-component')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }